import { Badge } from '@mui/material';
import { forwardRef } from 'react';

import AppBarIconButton from 'components/system/AppBar/AppBarIconButton';
import BelIcon from 'components/system/Icons/BelIcon';
import { INotificationButton } from './notifications.types';

const NotificationsButton = forwardRef<HTMLButtonElement, INotificationButton>(
  ({ onClick, newNotifications, ...rest }, ref) => (
    <AppBarIconButton
      onClick={onClick}
      edge="start"
      ref={ref}
      aria-label="Notifications"
      {...rest}
    >
      <Badge badgeContent={newNotifications} color="primary">
        <BelIcon />
      </Badge>
    </AppBarIconButton>
  ),
);

export default NotificationsButton;
